import React from 'react'
import { clsx } from 'clsx'

export interface CardProps {
  children: React.ReactNode
  className?: string | undefined
  padding?: 'none' | 'sm' | 'md' | 'lg' | undefined
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  padding = 'md',
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }

  return (
    <div
      className={clsx(
        'admin-card',
        paddingClasses[padding],
        className
      )}
    >
      {children}
    </div>
  )
}
